var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.ToolbarItemContainer,{ref:"container",attrs:{"iconFile":_setup.faceIcon,"title":"表情"},on:{"onDialogShow":_setup.onDialogShow,"onDialogClose":_setup.onDialogClose}},[_c(_setup.EmojiPickerDialog,{on:{"insertEmoji":_setup.insertEmoji,"sendMessage":_setup.sendMessage,"onClose":_setup.onClose}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }